module.exports = __webpack_public_path__ + "static/media/certificacao.90f06af0.png";